import { render, staticRenderFns } from "./DetallePersonal.vue?vue&type=template&id=4f70acd8&"
import script from "./DetallePersonal.vue?vue&type=script&lang=js&"
export * from "./DetallePersonal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports